<app-basic-simulator [config]="config"></app-basic-simulator>
